import React from 'react';
import './index.less';

import max from 'lodash/max';

function Countries({ className, geos }) {
	const maxCnt = max(geos.map(geo => geo.cnt));

	return (
		<div className={className}>
			<table className='analytics-countries-table'>
				<tbody>
					{geos.map((geo, i) => (
						<tr className='analytics-countries-row' key={i}>
							<td width={1}>
								<div className='analytics-countries-name'>
									{geo.country}
								</div>
							</td>
							<td>
								<div className='analytics-countries-line'>
									<div
										className='analytics-countries-fill'
										style={{
											right: `${100 - geo.cnt / maxCnt * 100}%`
										}}
									/>
								</div>
							</td>
							<td width={1}>
								<div className='analytics-countries-value'>
									{geo.cnt} <span title='процент апрува'>({geo.approval_percent}%)</span>
								</div>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}

export default Countries;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/info/components/Analytics/Countries/index.js